import React from 'react';
import PropTypes from 'prop-types';

import {OEMediaViewerContentSizeMode} from '../oe-media-viewer-model';
import OEColor from '../../color-picker/oe-color';

export default class OEMediaViewerContentController extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {
        let style;

        if(this.props.contentRect)  {
            if(this.props.contentRect.mode === OEMediaViewerContentSizeMode.fill)   {
                style = {backgroundColor: OEColor.toDOMStr(this.props.backgroundColor), width: '100%', height: '100%'};
            } else {
                style = {
                    backgroundColor: OEColor.toDOMStr(this.props.backgroundColor),
                    top: this.props.contentRect.top, 
                    right: this.props.contentRect.right, 
                    bottom: this.props.contentRect.bottom, 
                    left: this.props.contentRect.left, 
                    width:'auto', 
                    height:'auto'
                };
            }

        } else {
            style = { backgroundColor: 'rgba(0,0,0,0)', width: '100%', height: '100%' };
        }

        return (
            <div 
                className={'media-viewer-content ' + this.props.className}
            >
                <div 
                    className={'content-container'}
                    style={style}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

OEMediaViewerContentController.defaultProps = {
    className: ''
};

OEMediaViewerContentController.propTypes = {
    className: PropTypes.string
};